const authURL =
  "https://open.weixin.qq.com/connect/oauth2/authorize?appid={$1}&redirect_uri={$2}&response_type=code&scope=snsapi_userinfo&state={$3}#wechat_redirect";
const appid = "wxa07fd5b1e95b4f71";
const loginURL = "https://www.imonit.cn/wechatauthcb";

export const wexinAuthReq = () => {
  debugger;
  const state = encodeURIComponent(
    btoa(`${window.location.pathname}${window.location.search}`)
  );

  const url = authURL
    .replace("{$1}", appid)
    .replace("{$2}", loginURL)
    .replace("{$3}", state);
  console.log("wexinAuthReq:", url);
  window.location.replace(url);
};

export const getBarcodePath = (isMiniapp: boolean) => {
  return {
    url: `${process.env.BASE_URL}${
      isMiniapp ? "miniappBarcode.png" : "qrcode2.jpeg"
    }`,
    showText: !isMiniapp
  };
};

export const weChatPay = (prepayPackage: any) => {
  return new Promise((resolve, reject) => {
    if ((window as any).WeixinJSBridge) {
      (window as any).WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appid,
          timeStamp: prepayPackage.timeStampInSec,
          nonceStr: prepayPackage.nonceStr,
          package: prepayPackage.thePackage,
          signType: prepayPackage.signType,
          paySign: prepayPackage.sign
        },
        (res: any) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            return resolve();
          }
          console.error(prepayPackage, res);
          return reject();
        }
      );
    } else {
      reject();
    }
  });
};
